/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';


import {
    Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors, Field } from 'react-redux-form';

import axios from 'axios';
import Select from 'react-select';
// import AdminModal from './customModal';
// import EditJumper from './editJumper';
// import AddCard from './addCard'
// import DeleteJumper from './deleteJumper';
import { ClimbingBoxLoader, ClipLoader } from 'react-spinners';
import DatePicker from "react-datepicker";
import { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import JumperApi from '../../../services/jumpersapi';
import reservationStore from '../../../stores/reservation-store';
import Api from '../../../services/reservationapi';

import "react-datepicker/dist/react-datepicker.css";
import swal from 'sweetalert';
// import NabVelocity from "react-nab-velocity-checkout";
import NabVelocity from '../../sub-components/nab/nabVelocity';
import RemoveCard from './deleteCard';
import loadsStore from '../../../stores/loads-store';
// import WaiverDetail from '../../accounts/modals/waiverDetail';

import { ScaleLoader } from 'react-spinners';

import './jumperdetails.css';
import jumperStore from '../../../stores/jumpers-store';
import BottomNav from '../bottomNav';
import CardsContainer from './CardsContainer';
import AddCardButton from './CardButton';
import ForteACH from './forteAch';


const customStyles = {
    control: base => ({
        ...base,
        minHeight: 30
    }),
    menu: (provided, state) => ({
        ...provided,
        borderBottom: "1px dotted pink",
        color: state.isSelected ? "red" : "blue",
        padding: 20,
        height: 730
    }),
    menuList: (provided, state) => ({
        ...provided,
        borderBottom: "1px dotted pink",
        padding: 20,
        minHeight: 700
    })
};

class JumperDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jumperDetails: {},
            isLoading: true,
            cardArray: [],
            IsEdit: false,
            items: [],
            uspaExpiry: '',
            WaiverDate: '',
            reserveRepackDate: null,
            jumperOptions: [],
            adminDefaultOptions: [],
            chargeTo: '',
            transactionId: '',
            accountArray: [],
            isPayOutCharge: false,
        }

        this.jumperEvents = [
            { name: jumperStore.getEventPrefix('cardAddEvent'), func: this.addCardHandler },
            { name: jumperStore.getEventPrefix('jumperUpdated'), func: this.handleJumperUpdated },
            { name: jumperStore.getEventPrefix('jumpersLoaded'), func: this.handleJumpersLoaded },
            { name: jumperStore.getEventPrefix('deleteEvent'), func: this.handleDelete },
            { name: jumperStore.getEventPrefix('deleteCardEvent'), func: this.afterDeleteCard },

        ];
    }
    handleDelete = (result) => {
        setTimeout(() => {
            this.setState({
                isModalOpen: !this.state.isModalOpen,
            });
        }, 4000);
    }
    handleJumpersLoaded = (jumperOptions) => {
        //console.log('in handle jumpers loaded in accounts');
        var adminDefaultOptions = jumperOptions.slice(0, 50);
        //alert('handle Jumpers Loaded');
        this.setState({
            jumperOptions: jumperOptions,
            adminDefaultOptions: adminDefaultOptions
        })
    }
    handleJumperUpdated = (jumper) => {
        console.log("handleJumperUpdated: ", jumper)
        this.setState({
            jumperDetails: jumper,
            IsEdit: false
        });
        let userjson = JSON.stringify(jumper);
        localStorage.setItem('jumperDetails', userjson);
    }
    handleExpiryChange(date) {
        this.setState({
            uspaExpiry: date
        });
    }

    handleWaiverChange(date) {
        this.setState({
            WaiverDate: date
        });
    }
    handleRepackDateChange = date => {
        this.setState({
            reserveRepackDate: date
        })
    }

    componentDidMount() {
        this.jumperEvents.forEach((evnt) => jumperStore.on(evnt.name, evnt.func));
        window.MainApp = this;
        let { isLoading } = this.state;
        // console.log("IDDDdD",this.state.jumperDetails._id);
        if (isLoading) {
            jumperStore.loadAllJumpers()
                .then(res => {
                    if (res) {
                        let jumperDetails = localStorage.getItem("jumperDetails");
                        if (jumperDetails) {
                            let id = JSON.parse(jumperDetails)._id;
                            let jumper = jumperStore.getCardDetails(id);
                            // console.log("🚀 ~ file: jumperDetail.js ~ line 281 ~ JumperDetail ~ componentDidUpdate ~ jumper", jumper)
                            this.setState({
                                cardArray: jumper[0].cardsOnFile ? jumper[0].cardsOnFile : [],
                                jumperDetails: jumper[0],
                                isLoading: false,
                            })
                        }
                    }
                })
                .catch(err => {
                    console.log("ERRor Loading jumpers", err.message);
                    this.setState({
                        isLoading: false,
                    })
                })
        }

        var options = jumperStore.getJumperOptions();
        this.setState({ jumperOptions: options, adminDefaultOptions: options.slice(0, 50) });
    }
    
    componentWillUnmount = () => {
        this.jumperEvents.forEach((evnt) => jumperStore.removeListener(evnt.name, evnt.func));
    }

    addCardHandler = (cardsOnFile) => {
        console.log("🚀 ~ file: jumperDetail.js ~ line 159 ~ JumperDetail ~ cardsOnFile", cardsOnFile)

        this.setState({
            cardArray: cardsOnFile,
        })
    }
    toggleEditModal = () => {
        //alert('toggle edit modal');
        this.setState({
            IsEdit: !this.state.IsEdit
        })
    }
    renderCheckbox = () => {
        // alert("CheckBOxRating"+ JSON.stringify(this.state.items))
        return this.state.items.map((item, index) => {
            //return newItems.map((item, index) => {
            var ratingName = item.text + "_" + index;
            var ratingText = "txt_" + item.text + "_" + index;
            return (
                <Row className="form-group" key={index}>
                    <Col sm={1}>
                        <input type="checkbox" id={ratingName} name={ratingName} onChange={this.onToggle.bind(this, index)} checked={item.checked} />
                    </Col>

                    <Col sm={4}>
                        <label style={{ marginLeft: "10px" }}>{item.text}</label>
                    </Col>
                    <Col sm={7}>
                        <input type="text" id={ratingText} name={ratingText} className="rating-input"
                            style={{ width: "100% !important" }} onChange={this.handleChange.bind(this, index)} value={item.ratingNumber} />
                    </Col>
                </Row>
            )
        })
    }
    handleSubmit(values, jumperDetails) {
        // console.log("JUMPEdEtail: ",jumperDetails);
        var id = jumperDetails._id
        var payload = {};
        if (values.firstname != undefined) {
            payload.firstname = values.firstname;
        }
        else {
            payload.firstname = jumperDetails.firstname;
        }

        if (values.nickname != undefined) {
            payload.nickname = values.nickname;
        }

        if (values.lastname != undefined) {
            payload.lastname = values.lastname;
        }
        else {
            payload.lastname = jumperDetails.lastname;
        }

        if (values.email != undefined) {
            payload.email = values.email;
        }

        if (values.homePhone != undefined) {
            payload.homePhone = values.homePhone;
        }
        let payloadToSend = { ...jumperDetails, ...payload }
        //Remove some fields __v, _id
        delete payloadToSend.__v
        // console.log("payloadToSend: ",payloadToSend);


        let m = jumperStore.updateJumper(id, payloadToSend);
        // console.log("Updated SUCCESS: ",m);

        //alert('in submit');
        //this.toggleEditModal();
        // this.setState({ IsEdit: false })

        // ratingArray.forEach(rating => {
        //     //alert('calling jumperstore Add rating ' + JSON.stringify(rating));
        //     jumperStore.AddRating(jumperDetails.uspaMemberNumber, rating);
        // });
    }
    formatDate(input) {
        if (input.toString().length == 1) {
            return '0' + input;
        }
        else {
            return input;
        }
    }
    getJumperName() {
        let { jumperDetails } = this.state;
        if (jumperDetails) {
            return jumperDetails.firstname + " " + jumperDetails.lastname;
        }
        else {
            return '';
        }
    }
    checkForNegatives = (price) => {
        //console.log('check for negatives: ' + price);
        if (price != undefined) {
            let priceCell = (price < 0) ?
                {
                    value: `($${Math.abs(price)})`
                } :
                {
                    value: `$${price}`
                }
            if (price < 0) {
                return <span style={{ color: 'red' }}> {priceCell.value}</span>;
            }

            return <span>{priceCell.value}</span>;
        }
        else {
            return '';
        }
    }
    afterDeleteCard = (jumper) => {
        //after delete
        console.log("🚀 ~ file: jumperDetail.js ~ line 305 ~ JumperDetail ~ afterDeleteCard ~ jumper", jumper)
        this.setState({
            cardArray: jumper.cardsOnFile,
        })
    }
    IsEnableLoader = (isLoading) => {
        this.setState({
            isLoading: isLoading
        }, () => {
            return true
        })
    }
    render() {
        // console.log("IsEDIT: ",this.state.IsEdit)
        let { isLoading } = this.state;
        let { nickname, firstname, lastname, isStaff, ratings, uspaExpiry, waiverDate, homePhone, mobilePhone, email, uspaMemberNumber, manifestNumber, currentBalance, noPayOrCharge, multiManifest, discountRate, chargeTo, reserveRepackDate, lastFunJumpDate, lastTIJumpDate, lastSIJumpDate, lastCoachJumpDate, lastStudentJumpDate } = this.state.jumperDetails

        var expiryValue = '';
        var waiverValue = '';
        var reserveRepackvalue = '';

        var lastFunJumpValue = '';
        var lastTIJumpValue = '';
        var lastSIJumpValue = '';
        var lastStudentJumpValue = '';
        var lastCoachJumpValue = '';

        if (uspaExpiry !== undefined && uspaExpiry !== null) {
            var localDate = new Date(uspaExpiry);
            expiryValue = localDate.getFullYear() + "-" + this.formatDate(localDate.getMonth() + 1) + "-" + this.formatDate(localDate.getDate());
        }
        if (waiverDate !== undefined && waiverDate !== null) {
            var localDate1 = new Date(waiverDate);
            waiverValue = localDate1.getFullYear() + "-" + this.formatDate(localDate1.getMonth() + 1) + "-" + this.formatDate(localDate1.getDate());
        }
        if (reserveRepackDate !== undefined && reserveRepackDate !== null) {
            var localDate2 = new Date(reserveRepackDate);
            reserveRepackvalue = localDate2.getFullYear() + "-" + this.formatDate(localDate2.getMonth() + 1) + "-" + this.formatDate(localDate2.getDate());
        }

        if (lastFunJumpDate !== undefined && lastFunJumpDate !== null) {
            var localDate2 = new Date(lastFunJumpDate);
            lastFunJumpValue = localDate2.getFullYear() + "-" + this.formatDate(localDate2.getMonth() + 1) + "-" + this.formatDate(localDate2.getDate());
        }
        if (lastTIJumpDate !== undefined && lastTIJumpDate !== null) {
            var localDate2 = new Date(lastTIJumpDate);
            lastTIJumpValue = localDate2.getFullYear() + "-" + this.formatDate(localDate2.getMonth() + 1) + "-" + this.formatDate(localDate2.getDate());
        }
        if (lastSIJumpDate !== undefined && lastSIJumpDate !== null) {
            var localDate2 = new Date(lastSIJumpDate);
            lastSIJumpValue = localDate2.getFullYear() + "-" + this.formatDate(localDate2.getMonth() + 1) + "-" + this.formatDate(localDate2.getDate());
        }
        if (lastStudentJumpDate !== undefined && lastStudentJumpDate !== null) {
            var localDate2 = new Date(lastStudentJumpDate);
            lastStudentJumpValue = localDate2.getFullYear() + "-" + this.formatDate(localDate2.getMonth() + 1) + "-" + this.formatDate(localDate2.getDate());
        }
        if (lastCoachJumpValue !== undefined && lastCoachJumpValue !== null) {
            var localDate2 = new Date(lastCoachJumpValue);
            lastCoachJumpValue = localDate2.getFullYear() + "-" + this.formatDate(localDate2.getMonth() + 1) + "-" + this.formatDate(localDate2.getDate());
        }

        var accountRender = '';
        if (this.state.jumperDetails && this.state.jumperDetails.accountOnFile !== undefined) {
            var accountRender = this.state.jumperDetails.accountOnFile.map(cardOnFile => {
                // var cardNumber = "XXXX-XXXX-XXXX-" + cardOnFile.cardNumLast4;
                var accountNumber = cardOnFile.AccountNumber;
                return (
                    <Row style={{ marginBottom: '20px' }}>
                        <Col md={{ size: 4 }}>Account Number: </Col>
                        <Col md={{ size: 7 }}>{accountNumber}</Col>
                        <Col md={{ size: 1 }}><RemoveCard jumperId={this.state.jumperDetails._id} cardId={cardOnFile._id} type="account" /></Col>
                    </Row>
                );
            })
        }
        return (

            <div className="col bodyView" style={{ height: '95vh' }}>
                {
                    isLoading ? (
                        <div style={{ position: 'absolute', left: '48%', top: '40%', zIndex: '999999' }}>
                            <div className='sweet-loading'>
                                <ScaleLoader
                                    height={35}
                                    width={8}
                                    margin={'2px'}
                                    radius={2}
                                    color={'#123abc'}
                                />
                                <p>Please wait...</p>
                            </div>
                        </div>
                    ) : (
                            <div className="mainContainer daily-activity">
                                <h4 className="heading">Jumper Details</h4>
                                <hr className="w-100" />
                                <Row>
                                    <Col className="card-div">
                                        <AddCardButton jumperId={this.state.jumperDetails._id} />
                                        <div className="bluebtn">
                                            <ForteACH />
                                        </div>
                                        <div className="editbtn">
                                            <i className="fa fa-edit" onClick={this.toggleEditModal} style={{ fontSize: '23px' }}></i>
                                        </div>

                                    </Col>
                                </Row>

                                <LocalForm
                                    onSubmit={(values) => this.handleSubmit(values, this.state.jumperDetails)}
                                    className="detail-form"
                                >

                                    <Row className="form-group m-t-1-rem">
                                        <Col md={{ size: 12 }}>

                                            <div style={{ marginTop: this.state.IsEdit ? "28px" : 0, marginLeft: "20px", }}>
                                                {
                                                    !this.state.IsEdit
                                                        ?
                                                        <h5>{firstname}  {lastname} - {firstname !== nickname ? nickname : null}</h5>
                                                        : ''
                                                }
                                                <h6>{!this.state.IsEdit && isStaff ?
                                                    <span style={{ fontSize: '15px', backgroundColor: '#1b5ba1' }} className="badge">
                                                        staff
                                    		</span>
                                                    : null}</h6>
                                                <h6>{!this.state.IsEdit && noPayOrCharge ?
                                                    <span style={{ fontSize: '15px', backgroundColor: '#1b5ba1' }} className="badge">
                                                        no Pay Or Charge
                                            		</span>
                                                    : null}
                                                </h6>
                                                <h6>{!this.state.IsEdit && multiManifest ?
                                                    <span style={{ fontSize: '15px', backgroundColor: '#1b5ba1' }} className="badge">
                                                        allow multiple manifest
                                            </span>
                                                    : null}
                                                </h6>

                                                {this.state.IsEdit &&
                                                    <Row>
                                                        <Col md={4}>First Name</Col>
                                                        <Col md={8}>
                                                            <Control.input name="firstname" model=".firstname" className="form-control"
                                                                mapProps={{ onChange: (props) => props.onChange }} defaultValue={firstname} autoComplete="off" />
                                                        </Col>
                                                    </Row>
                                                }

                                                {this.state.IsEdit &&
                                                    <Row>
                                                        <Col md={4}>Nickname</Col>
                                                        <Col md={8}>
                                                            <Control.input name="nickname" model=".nickname" className="form-control"
                                                                mapProps={{ onChange: (props) => props.onChange }} defaultValue={nickname} autoComplete="off" />
                                                        </Col>
                                                    </Row>
                                                }

                                                {this.state.IsEdit &&
                                                    <Row>
                                                        <Col md={4}>Last Name</Col>
                                                        <Col md={8}>
                                                            <Control.input name="lastname" model=".lastname" className="form-control"
                                                                mapProps={{ onChange: (props) => props.onChange }} defaultValue={lastname} autoComplete="off" />
                                                        </Col>
                                                    </Row>
                                                }



                                                {!this.state.IsEdit ?
                                                    <Row>
                                                        {email !== undefined ?
                                                            <Col md={{ size: 8 }}>
                                                                <span style={{ marginRight: '4px' }}><i className="fa fa-envelope" aria-hidden="true"></i> </span>
                                                                {email}
                                                            </Col>
                                                            : ''
                                                        }
                                                    </Row>
                                                    :
                                                    <Row>
                                                        <Col md={4}>Email</Col>
                                                        <Col md={8}>
                                                            <Control.input name="email" model=".email" className="form-control"
                                                                mapProps={{ onChange: (props) => props.onChange }} defaultValue={email} autoComplete="off" />
                                                        </Col>
                                                    </Row>
                                                }
                                                {/* :
                                            null
                                    } */}
                                                {!this.state.IsEdit ?
                                                    <Row>
                                                        {homePhone !== undefined ?
                                                            <Col md={{ size: 8 }}>
                                                                <span style={{ marginRight: '4px' }}><i className="fa fa-phone" aria-hidden="true"></i> </span>
                                                                {homePhone}
                                                            </Col>
                                                            : ''}
                                                    </Row>
                                                    :
                                                    <Row>
                                                        <Col md={4}>Phone</Col>
                                                        <Col md={8}>
                                                            <Control.input name="homePhone" model=".homePhone" className="form-control"
                                                                mapProps={{ onChange: (props) => props.onChange }} defaultValue={homePhone} autoComplete="off" />
                                                        </Col>
                                                    </Row>
                                                }

                                                {/* {
                                        mobilePhone !== undefined ? */}

                                                {!this.state.IsEdit ?
                                                    <Row>
                                                        {mobilePhone !== undefined ?
                                                            <Col md={{ size: 8 }}>
                                                                <span style={{ marginRight: '4px' }}><i className="fa fa-phone" aria-hidden="true"></i> </span>
                                                                {mobilePhone}
                                                            </Col>
                                                            : ''
                                                        }
                                                    </Row>
                                                    : null
                                                }
                                                {/* :
                                            null
                                    } */}

                                                {!this.state.IsEdit ?
                                                    <br />
                                                    : ''}

                                                {!this.state.IsEdit ?
                                                    <div>
                                                        {uspaMemberNumber !== undefined ?
                                                            <Row>
                                                                <Col xs={{ size: 5 }}>Uspa Number:  </Col>
                                                                <Col xs={{ size: 7 }}>{uspaMemberNumber}</Col>
                                                            </Row>
                                                            : ''}
                                                    </div>
                                                    : null
                                                }

                                                {!this.state.IsEdit ?
                                                    <div>
                                                        {manifestNumber !== undefined ?
                                                            <Row>
                                                                <Col xs={{ size: 5 }}>Manifest Number:  </Col>
                                                                <Col xs={{ size: 7 }}>{manifestNumber}</Col>
                                                            </Row>
                                                            : ''}
                                                    </div>
                                                    : null
                                                }


                                                {!this.state.IsEdit ?
                                                    <div>
                                                        {uspaExpiry !== undefined && uspaExpiry != null ?
                                                            <Row>
                                                                <Col xs={{ size: 5 }}>Uspa Expiry:  </Col>
                                                                <Col xs={{ size: 7 }}>
                                                                    {expiryValue}
                                                                    {/* {(new Date(uspaExpiry).toString())} */}
                                                                    {/* var date= new Date(desc.date);  */}
                                                                    {

                                                                        // date.getFullYear() + "-" + this.formatDate(date.getMonth() + 1) + "-" + this.formatDate(date.getDate()) + " " + this.formatDate(date.getHours())
                                                                    }
                                                                </Col>
                                                            </Row>
                                                            : ''}
                                                    </div>
                                                    : null
                                                }

                                                {/* {
                                        uspaExpiry !== undefined ?
                                            <Row>
                                                <Col xs={{ size: 5 }}>Uspa Expiry:  </Col>
                                                {!this.state.IsEdit ?
                                                    <Col xs={{ size: 7 }}>{(new Date(uspaExpiry).toString())}</Col>
                                                    :
                                                    <Col xs={7}>
                                                        <Control.input name="uspaExpiry" model=".uspaExpiry" className="form-control"
                                                            mapProps={{ onChange: (props) => props.onChange }} defaultValue={uspaExpiry} autoComplete="off" />
                                                    </Col>}
                                            </Row>
                                            : ''
                                    } */}


                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {waiverDate !== undefined && waiverDate !== null ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Waiver Date:  </Col>
                                                                    <Col xs={{ size: 7 }}>{waiverValue}</Col>

                                                                    {/* <Col xs={{ size: 7 }}>{(new Date(waiverDate).toString())}</Col> */}
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        : null
                                                }
                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {reserveRepackDate !== undefined && reserveRepackDate !== null ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Reserve Repack Date:  </Col>
                                                                    <Col xs={{ size: 7 }}>{reserveRepackvalue}</Col>

                                                                    {/* <Col xs={{ size: 7 }}>{(new Date(waiverDate).toString())}</Col> */}
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        : null
                                                }
                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {lastTIJumpDate !== undefined && lastTIJumpDate !== null ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Last TI Jump Date:  </Col>
                                                                    <Col xs={{ size: 7 }}>{lastTIJumpValue}</Col>
                                                                    {/* <Col xs={{ size: 7 }}>{(new Date(waiverDate).toString())}</Col> */}
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {lastSIJumpDate !== undefined && lastSIJumpDate !== null ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>last Instructor Jump Date:  </Col>
                                                                    <Col xs={{ size: 7 }}>{lastSIJumpValue}</Col>

                                                                    {/* <Col xs={{ size: 7 }}>{(new Date(waiverDate).toString())}</Col> */}
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {lastStudentJumpDate !== undefined && lastStudentJumpDate !== null ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Last Student Jump Date:  </Col>
                                                                    <Col xs={{ size: 7 }}>{lastStudentJumpValue}</Col>

                                                                    {/* <Col xs={{ size: 7 }}>{(new Date(waiverDate).toString())}</Col> */}
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {lastCoachJumpDate !== undefined && lastCoachJumpDate !== null ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Last Coach Jump Date:  </Col>
                                                                    <Col xs={{ size: 7 }}>{lastCoachJumpValue}</Col>

                                                                    {/* <Col xs={{ size: 7 }}>{(new Date(waiverDate).toString())}</Col> */}
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {lastFunJumpDate !== undefined && lastFunJumpDate !== null ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Last Fun Jump Date:  </Col>
                                                                    <Col xs={{ size: 7 }}>{lastFunJumpValue}</Col>

                                                                    {/* <Col xs={{ size: 7 }}>{(new Date(waiverDate).toString())}</Col> */}
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        :
                                                        null
                                                }

                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {discountRate !== undefined ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Discount:  </Col>
                                                                    <Col xs={{ size: 7 }}>${discountRate}</Col>
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        : null
                                                }


                                                {
                                                    !this.state.IsEdit ?
                                                        <div>
                                                            {chargeTo !== undefined ?
                                                                <Row>
                                                                    <Col xs={{ size: 5 }}>Charge To:  </Col>
                                                                    <Col xs={{ size: 7 }}>{this.getJumperName(chargeTo)}</Col>
                                                                </Row>
                                                                : ''}
                                                        </div>
                                                        : null
                                                }



                                                {
                                                    currentBalance != undefined && !this.state.IsEdit ?
                                                        <Row style={{ marginBottom: '20px' }}>
                                                            <Col xs={{ size: 5 }}>Current Balance:  </Col>
                                                            <Col xs={{ size: 7 }}>{this.checkForNegatives(currentBalance)}</Col>
                                                        </Row>
                                                        : ''
                                                }



                                                {!this.state.IsEdit ?
                                                    <div>
                                                        {
                                                            noPayOrCharge != undefined && noPayOrCharge != null && noPayOrCharge != false
                                                                ?
                                                                <Row>
                                                                    <Col xs={{ size: 12 }}>No pay or Charge</Col>
                                                                </Row>
                                                                : ''
                                                        }
                                                    </div>
                                                    : null
                                                }

                                                {!this.state.IsEdit ?
                                                    <div>
                                                        {
                                                            multiManifest != undefined && multiManifest != null && multiManifest != false
                                                                ?
                                                                <Row>
                                                                    <Col xs={{ size: 12 }}>allow multiple manifest</Col>
                                                                </Row>
                                                                : ''
                                                        }
                                                    </div>
                                                    : null
                                                }

                                                {/* {
                                        waiverDate !== undefined ?
                                            <Row style={{ marginBottom: '20px' }}>
                                                <Col xs={{ size: 4 }}>Waiver Date:  </Col>
                                                {!this.state.IsEdit ?
                                                    <Col xs={{ size: 8 }}>{(new Date(waiverDate).toString())}</Col>
                                                    :
                                                    <Col xs={8}>
                                                        <Control.input name="waiverDate" model=".waiverDate" className="form-control"
                                                            mapProps={{ onChange: (props) => props.onChange }} defaultValue={waiverDate} autoComplete="off" />
                                                    </Col>}
                                            </Row>
                                            : ''
                                    } */}


                                                {
                                                    !this.state.IsEdit ?
                                                        <hr style={{ background: 'white' }} />
                                                        : ''
                                                }


                                                {!this.state.IsEdit ?
                                                    <ul className="star-list" style={{ marginTop: '15px', listStyle: 'none' }}>
                                                        {ratings != undefined && ratings.map(function (jumper, index) {
                                                            return <li key={index}>
                                                                <span style={{ marginRight: '4px' }}> <i className="fa fa-star" aria-hidden="true"></i> </span>
                                                                {jumper.rating} : {jumper.number}
                                                            </li>;
                                                        })}
                                                    </ul>
                                                    : ''
                                                }

                                                {/*
                                        //un comment to diplay an edit field also add renderCheckbox() function
                                    {this.state.IsEdit ?
                                        <Row className="form-group">
                                            <Label htmlFor="pilot" md={3}>Rating</Label>
                                            <div style={{ paddingLeft: '18px' }}>
                                                {this.renderCheckbox()}
                                            </div>
                                        </Row>
                                        : ''
                                    } */}


                                                <CardsContainer
                                                    cardArray={this.state.cardArray} jumperId={this.state.jumperDetails._id}
                                                />

                                                {
                                                    accountRender
                                                }

                                            </div>

                                        </Col>
                                    </Row>

                                    <Row className="form-group m-t-2-rem">
                                        <Col md={{ size: 9 }}>
                                            {/* <button className="btn btn-bg lightColor createButton" type="submit" >SUBMIT</button> */}
                                            {!this.state.IsEdit ?
                                                <button type="submit" onClick={(e) => { e.preventDefault(); }} className="btn btn-link"></button>
                                                :
                                                <div>
                                                    <button className="btn btn-link">SAVE</button>
                                                    <button className="btn btn-link" onClick={this.toggleEditModal}>CANCEL</button>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </LocalForm>
                            </div>
                        )
                }
                <BottomNav history={this.props.history} componentToRender={2} />

            </div>
        )

    }
}

export default JumperDetail;
